import React from 'react';

import styled from 'styled-components/macro';

const Img = styled('img')`
  display: none;
  height: 1px;
  width: 1px;
  position: fixed;
  bottom: 0;
  right: 0;
`;

export const PixelTrackingImage: React.FC<{src: string}> = ({src}) => <Img src={src} />;
